import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import AccountTypeCard from '../../components/AccountTypeCard';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Column } from 'web-ui-components/lib/global/layout';

import { CommonShell } from '../../components/common/CommonShell/CommonShell';
import { isLoading, isSMEAlertEnable } from '../../infrastructure/config/selectors';
import { TransactionAmount } from '../../components/TransactionAmount';
import { getTransactionAccountData, isButtonDisabled } from '../../businessLogic/AlertsBL';
import { isEmpty, startsWith } from 'lodash';
import { FIX_DECIMAL_BY_TWO, INCOMING_TRANSACTION_LIMIT } from '../../constants/StringConstants';
import {
  getAccountDetails,
  stripIllegalCharacters,
  amountWithinLimit,
} from '../../businessLogic/AccountsBL';
import { fixAmount } from '../../utils/NumberUtils';
import { CommonModal } from '../../components/common/CommonModal';

export class IncomingTransactionAlertsPage extends Component {
  constructor(props) {
    super(props);
    this.backClick = this.backClick.bind(this);
    this.cancelAlertChanges = this.cancelAlertChanges.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleTransactionBalRequestPacket = this.handleTransactionBalRequestPacket.bind(this);
    this.closeUpdateModal = this.closeUpdateModal.bind(this);
    this.retryRequest = this.retryRequest.bind(this);
    const {
      amountTransactionAlerts: {
        amount: { value: transactionAmount },
      },
    } = props;
    this.state = {
      transactionAmount: transactionAmount.toFixed(FIX_DECIMAL_BY_TWO),
    };
  }
  componentDidUpdate(prevProps) {
    const { masterCardLeavePopup, isEditModeEnabled } = this.props;
    if (masterCardLeavePopup && prevProps.isEditModeEnabled !== isEditModeEnabled) {
      masterCardLeavePopup(isEditModeEnabled);
    }
  }
  componentWillUnmount() {
    const { masterCardLeavePopup, showTransactionAmountError, editModeEnabled, showButton } =
      this.props;
    if (masterCardLeavePopup) {
      masterCardLeavePopup(false);
    }
    editModeEnabled(false);
    showButton(false);
    showTransactionAmountError(false);
  }
  backClick() {
    const { routeTo, isEditModeEnabled, showUnsavedLeavePopup } = this.props;
    if (isEditModeEnabled) {
      showUnsavedLeavePopup(true);
    } else {
      routeTo('/transactions');
    }
  }
  cancelAlertChanges() {
    const { showButton, amountTransactionAlerts, editModeEnabled } = this.props;
    showButton(false);
    editModeEnabled(false);
    this.setState({
      transactionAmount: amountTransactionAlerts.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
    });
  }
  handleAmountChange(event) {
    const { showButton, showTransactionAmountError, amountTransactionAlerts, editModeEnabled } =
      this.props;
    const {
      amount: { value: transactionAmount },
    } = amountTransactionAlerts;
    const amount = stripIllegalCharacters(event.target.value);
    if (amount) {
      editModeEnabled(true);
    }
    showButton(isButtonDisabled(amount, transactionAmount));
    showTransactionAmountError(
      isEmpty(amount) || amount <= INCOMING_TRANSACTION_LIMIT || startsWith(amount, '.')
    );
    if (amountWithinLimit(amount)) {
      this.setState({ transactionAmount: amount });
    }
  }
  handleOnBlur(event) {
    const {
      showButton,
      amountTransactionAlerts: {
        amount: { value: transactionAmount },
      },
    } = this.props;
    const amount = fixAmount(event.target.value);
    this.setState({ transactionAmount: amount });
    showButton(isButtonDisabled(amount, transactionAmount));
  }
  handleTransactionBalRequestPacket(transactionRequestPacket, alertType) {
    const {
      updateIncomingTransactionAlerts,
      accountDetails,
      amountTransactionAlerts,
      editModeEnabled,
      showTransactionAmountError,
    } = this.props;
    updateIncomingTransactionAlerts(transactionRequestPacket, accountDetails.id);
    alertType === 'toggle' &&
      this.setState({
        transactionAmount: amountTransactionAlerts.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
      });
    editModeEnabled(false);
    showTransactionAmountError(false);
  }
  retryRequest() {
    const {
      updateIncomingTransactionAlerts,
      incomingTransactionRequestPacket,
      accountDetails,
      closePopup,
    } = this.props;
    closePopup(false);
    updateIncomingTransactionAlerts(incomingTransactionRequestPacket, accountDetails.id);
  }
  closeUpdateModal() {
    const { showUnsavedLeavePopup, routeTo, isSMEAlertEnable } = this.props;
    showUnsavedLeavePopup(false);
    isSMEAlertEnable ? routeTo('/transactions') : routeTo('/singlealerts');
  }
  render() {
    const {
      accountDetails,
      content,
      showButton,
      showAmountButton,
      transactionAmountValidation,
      isLoading,
      amountTransactionAlerts,
      transactionError,
      closePopup,
      isLeavePopupEnable,
      showUnsavedLeavePopup,
    } = this.props;
    const { transactionAmount } = this.state;
    return (
      <CommonShell backClick={this.backClick}>
        <PageHeading>{content.incomingTransactionsHeading}</PageHeading>
        <AccountTypeCard accountDetails={accountDetails} />
        <Column className="u-margin-top-2">
          <TransactionAmount
            content={content}
            isTransactionAmountEnable={amountTransactionAlerts.enabled}
            defaultAmount={amountTransactionAlerts.amount.value}
            transactionAmount={transactionAmount}
            handleAmountChange={this.handleAmountChange}
            handleTransactionBalRequestPacket={this.handleTransactionBalRequestPacket}
            showButton={(buttonState) => {
              showButton(buttonState);
            }}
            cancelAlertChanges={this.cancelAlertChanges}
            isLoading={isLoading}
            showAmountButton={showAmountButton}
            isAmountValid={transactionAmountValidation}
            handleOnBlur={this.handleOnBlur}
            incomingTransactionValidation={true}
          />
        </Column>
        {transactionError && (
          <CommonModal
            isOpen={transactionError}
            onRequestClose={() => {
              closePopup(false);
            }}
            onPrimaryBtnClick={() => {
              this.retryRequest();
            }}
          />
        )}
        {isLeavePopupEnable && (
          <CommonModal
            isOpen={isLeavePopupEnable}
            onRequestClose={this.closeUpdateModal}
            onPrimaryBtnClick={() => {
              showUnsavedLeavePopup(false);
            }}
            header={content.leavePopupHeader}
            infoCardContent={content.leavePopupContent}
            primaryBtnName={content.leavePopupPrimaryBtnName}
            secondaryBtnName={content.leavePopupSecondaryBtnName}
          />
        )}
      </CommonShell>
    );
  }
}

IncomingTransactionAlertsPage.propTypes = {
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({}),
  backClick: PropTypes.func,
  routeTo: PropTypes.func,
  amountTransactionAlerts: PropTypes.shape({
    amount: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  showButton: PropTypes.func,
  showAmountButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  showTransactionAmountError: PropTypes.func,
  transactionAmountValidation: PropTypes.bool,
  updateIncomingTransactionAlerts: PropTypes.func,
  transactionError: PropTypes.bool,
  closePopup: PropTypes.func,
  editModeEnabled: PropTypes.func,
  isEditModeEnabled: PropTypes.bool,
  showUnsavedLeavePopup: PropTypes.func,
  isLeavePopupEnable: PropTypes.bool,
  isSMEAlertEnable: PropTypes.bool,
  masterCardLeavePopup: PropTypes.func,
  incomingTransactionRequestPacket: PropTypes.array,
};
const mapStateToProps = (state) => {
  const { accountList, bulkTransactionAlerts, config, validation, loader } = state;
  const accountId = accountList.get('selectedAccountId');
  const transactionAlerts = bulkTransactionAlerts.get('incomingTransactionAlerts').credit_alert;
  return {
    selectedAccountId: accountId,
    userInfo: config.get('userInfo'),
    accountDetails: getAccountDetails(accountId, accountList.get('accountList').accounts),
    showAmountButton: bulkTransactionAlerts.get('showButton'),
    amountTransactionAlerts: getTransactionAccountData(transactionAlerts, 'amount'),
    transactionAmountValidation: validation.get('transactionAmountValidation'),
    isLoading: isLoading(loader),
    transactionError: bulkTransactionAlerts.get('incomingTransactionError'),
    incomingTransactionRequestPacket: bulkTransactionAlerts.get('incomingTransactionRequestPacket'),
    isEditModeEnabled: validation.get('enableEditMode'),
    isLeavePopupEnable: validation.get('enableUnsavedLeavePopup'),
    isSMEAlertEnable: isSMEAlertEnable(state),
  };
};
const mapDispatch = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatch)(IncomingTransactionAlertsPage);
